import {
  TrackerConnectorApollo,
  TrackerRemoveMealConnectorApollo,
  TrackerRemoveActivityConnectorApollo,
  TrackerUnlinkActivityConnectorApollo,
  TrackerCacheConnectorApollo,
  createDateObject,
  FetchNotificationConnectorRemoteConfig,
  FetchClosedNotificationsConnectorFirestoreDb,
} from '@front-activerse/common-components';
import { formatIsoDate } from '@front-activerse/common-components';
import TrackerContainer from './TrackerContainer';
import { useParams, useNavigate } from 'react-router-dom';
import { useApolloClient } from '@apollo/client';
import { UserDataQuery } from '@front-activerse/common-components';

interface ITrackerIndexPageProps {
  trackerArticleId: number;
  fetchRemoteConfigFields: (
    fields: string[]
  ) => Promise<{ [key: string]: string | number | boolean }>;
  getClosedNotifications: (collectionName: string, userId: number) => Promise<number[]>;
  markNotificationAsClosed: (
    collectionName: string,
    userId: number,
    notificationId: number
  ) => Promise<void>;
}

const TrackerIndexPage: React.FC<ITrackerIndexPageProps> = ({
  trackerArticleId,
  fetchRemoteConfigFields,
  getClosedNotifications,
  markNotificationAsClosed,
}) => {
  const { date } = useParams();
  const navigate = useNavigate();
  const dateString = date ? date : formatIsoDate(new Date());

  const dateObject = createDateObject(dateString);

  const client = useApolloClient();

  const userData = client.readQuery({
    query: UserDataQuery,
    variables: { date: dateString },
  });

  const userId = userData?.me?.id || 0;

  return (
    <FetchClosedNotificationsConnectorFirestoreDb
      getClosedNotifications={getClosedNotifications}
      userId={userId}
      collectionName="tracker_notifications"
    >
      {({ ...fetchClosedNotificationsData }) => (
        <FetchNotificationConnectorRemoteConfig
          fetchRemoteConfigFields={fetchRemoteConfigFields}
          remoteConfigFields={['tracker_notification_active', 'tracker_notification_id']}
        >
          {({ ...fetchTrackerNotificationData }) => (
            <TrackerConnectorApollo date={dateString}>
              {(result) => (
                <TrackerCacheConnectorApollo date={dateObject}>
                  {({ prefetchSurroundingDays }) => (
                    <TrackerRemoveMealConnectorApollo date={dateString}>
                      {({ removeMeal }) => (
                        <TrackerRemoveActivityConnectorApollo date={dateString}>
                          {({ removeActivity }) => (
                            <TrackerUnlinkActivityConnectorApollo date={dateString}>
                              {({ unlinkActivity }) => {
                                if (result.trackerData === null) {
                                  navigate('/tracker/settings/');
                                }

                                return (
                                  <TrackerContainer
                                    {...result.trackerData}
                                    aiAccess={result.aiAccess}
                                    dietAccess={result.dietAccess}
                                    date={dateString}
                                    removeMeal={removeMeal}
                                    removeActivity={removeActivity}
                                    unlinkActivity={unlinkActivity}
                                    prefetchSurroundingDays={prefetchSurroundingDays}
                                    trackerArticleId={trackerArticleId}
                                    markNotificationAsClosed={markNotificationAsClosed}
                                    {...fetchTrackerNotificationData}
                                    {...fetchClosedNotificationsData}
                                    loadingTrackerNotification={
                                      fetchTrackerNotificationData.loading ||
                                      fetchClosedNotificationsData.loading
                                    }
                                    userId={userId}
                                    loading={result.loading || result.trackerData === null}
                                  />
                                );
                              }}
                            </TrackerUnlinkActivityConnectorApollo>
                          )}
                        </TrackerRemoveActivityConnectorApollo>
                      )}
                    </TrackerRemoveMealConnectorApollo>
                  )}
                </TrackerCacheConnectorApollo>
              )}
            </TrackerConnectorApollo>
          )}
        </FetchNotificationConnectorRemoteConfig>
      )}
    </FetchClosedNotificationsConnectorFirestoreDb>
  );
};

export default TrackerIndexPage;
